module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAAXNSR0IArs4c6QAAALNJREFUWAntlUEOglAMRKfGaylxCXtP4jk8gAeRrYHTeApqv27I8DFdmJiQ+StmfqHTF5ICOiIgAiKwEQKWmWMYHhe4d5naRY1Z3zSn68InY0+6Lj8hnjAb6wUr7uSHGKCN2x8FKX0iREx2W2lZtYMkMPm5eknmjvTfpIIwehERESbAWv+IiDAB1rmlV95yP753B3/hmy5LL3lSQRy4m6OLMKkFNu/thn6u9SwCIiACmyfwAuX9JJewNv7zAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/icon_juxing.png
// module id = 1Yh1
// module chunks = 1